import nightCafe from './night-cafe.json';

// Box within the plate, as fractions of its width/height (0–1)
export interface SceneBox {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface SceneSeat extends SceneBox {
  id: string;
  label?: string; // where it is, e.g. "by the window" (used in join/leave notices)
  video: string; // looping clip of this region with the character in it
  poster: string; // first frame, shown while the clip loads
  mask?: string; // soft alpha silhouette: only the character is drawn over the plate
  // The whole figure as a still (legs and all), drawn under the clip; covers
  // parts of the person that fall outside the clip's box
  still?: SceneBox & { src: string };
}

// Generated by scripts/world/generate-world.mjs; assets live in public/worlds/<id>/
// A look you can pick for yourself: the hero seat with a different person
export interface SceneLook extends SceneSeat {
  look: string;
  lookLabel: string;
  portrait: string;
}

export interface Scene {
  id: string;
  name: string;
  ready: boolean;
  aspect: number; // plate width / height
  plate: { image: string; video: string };
  hero: SceneSeat | null; // where "you" sit, in your own view
  looks?: SceneLook[]; // who "you" can be; the first is the default hero
  seats: SceneSeat[]; // shared seats, filled by other people
}

export const activeScene = nightCafe as Scene;
